import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const DistillersPageContext = React.createContext({});
export let distillersPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMDistillersGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  distillersPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(distillersPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    distillersPageMachine,
    distillersPageState: state,
    distillersPageSend: send,
  };
};
